exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{border-color:red!important}.post_input,.post_select,.post_select.disabled{position:relative;background:#fff;border:1px solid #eaeaea;box-shadow:none;outline:none;font:400 16px/40px Source Sans Pro,sans-serif;padding:0 25px;height:auto;border-radius:5px;color:rgba(0,0,0,.6);min-width:100%}.post_select.disabled .list,.post_select .list{height:305%!important}.buy-car-box{background:#181a3c;color:#fff;padding:20px}.content-card{padding-bottom:100px;background-color:#f5f5f5}.border{padding:2px}.letters-colored{color:#f59019}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dbbc877","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/BuyCar.vue
// module id = 404
// module chunks = 0